export function initIntercom(userJwt, userFirstName) {
  window.Intercom("boot", {
    api_base: process.env.VUE_API_INTERCOM_API_BASE,
    app_id: process.env.VUE_APP_INTERCOM_APP_ID,
    intercom_user_jwt: userJwt,
    name: userFirstName,
  });
}
